import { OperatingSystem } from '@/constants'

export const getUserAgent = (): OperatingSystem => {
  const userAgent = navigator.userAgent
  if (/android/i.test(userAgent)) {
    return OperatingSystem.Android
  } else if (/iPad|iPhone|iPod/.test(userAgent)) {
    return OperatingSystem.IOS
  } else {
    return OperatingSystem.Other
  }
}
